import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

export const NotaryAlertsToggle = () => {
  const [on, setOn] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/provider/notification-prefs")
      .then(({ data }) => { setOn(data.notary_routing !== false); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  const toggle = async () => {
    const next = !on;
    setOn(next);
    setSaving(true);
    try {
      await api.put("/provider/notification-prefs", { notary_routing: next });
      toast.success(next ? "Notary opportunity alerts on" : "Notary opportunity alerts off");
    } catch {
      setOn(!next);
      toast.error("Could not update your alert setting");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-5" data-testid="notary-alerts-toggle-card">
      <div className="flex items-start gap-3">
        <Bell className="mt-0.5 h-5 w-5 text-indigo-500" />
        <div>
          <h3 className="font-display text-lg font-bold text-slate-900">Notary opportunity alerts</h3>
          <p className="mt-1 text-sm text-slate-500">Get an email + in-app alert when a notary job matching your counties opens. You can still see and claim any job in Notary Jobs either way.</p>
        </div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={on}
        data-testid="notary-alerts-toggle"
        disabled={!loaded || saving}
        onClick={toggle}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${on ? "bg-indigo-600" : "bg-slate-300"} ${(!loaded || saving) ? "opacity-60" : ""}`}
      >
        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${on ? "translate-x-6" : "translate-x-1"}`} />
      </button>
    </div>
  );
};
